module.exports = __webpack_public_path__ + "fonts/font.3d60318.woff";